const removeTTWaterMark = {
  HitPawTikTokTitle: 'HitPaw Online TikTok Watermark Remover',
  ExportVideoWithoutWaterMark: 'Export Video Without HitPaw Watermark',
  ProcessTiktokLinkWithoutLimits: 'Process Tiktok Link Without Limits',
  FasterProcessingSpeed: '10X Faster processing speed',
  PrioritySupport: 'Priority Support',
  DiscountPrice: '$0.99',
  WeekTotalPrice: '$4.49',

  MonthWeekPrice: '$1.75',
  MonthTotalPrice: '$6.99',

  YearWeekPrice: '$0.87',
  YearTotalPrice: '$41.88',
  Day: 'Day',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
  week: 'week',
};

export default removeTTWaterMark;
